import apiClient from './apiClient'
import { SocialLink } from '../../model/SocialLink'
import { iconCodeToName, iconNameToCode, normalizeSocialUrl } from '../../utils/socialIcons'

// Backend SocialLinkResponse { id, url, icon(name) } → client SocialLink(id, url, code, pageId).
// The backend response has no pageId, so the caller supplies it (always known by the caller).
function toSocialLink(social, pageId) {
    return new SocialLink(social.id, social.url, iconNameToCode(social.icon), pageId)
}

/** Social links for a page (public endpoint). */
export async function getSocialLinks(pageId) {
    const { data } = await apiClient.get(`/socials/vp/${pageId}`)
    return (data || []).map((social) => toSocialLink(social, pageId))
}

/** Adds a social link; returns the created SocialLink. */
export async function addSocialLink(socialLink) {
    const body = { url: normalizeSocialUrl(socialLink.icon, socialLink.url), iconName: iconCodeToName(socialLink.icon) }
    const { data } = await apiClient.post(`/socials/${socialLink.videoPageId}`, body)
    return toSocialLink(data, socialLink.videoPageId)
}

/** Updates a social link by its id; returns the updated SocialLink. */
export async function updateSocialLink(socialLink) {
    const body = { url: normalizeSocialUrl(socialLink.icon, socialLink.url), iconName: iconCodeToName(socialLink.icon) }
    const { data } = await apiClient.put(`/socials/${socialLink.id}`, body)
    return toSocialLink(data, socialLink.videoPageId)
}

export async function deleteSocialLink(socialId) {
    await apiClient.delete(`/socials/${socialId}`)
}
